module.exports = __webpack_public_path__ + "static/img/loginLogo.359fa701.png";